/**
 * This file essentially allows us to import widget components and stores into the main application
 */
 import Vue from "vue";
 import store from "@/store.js";
 import WidgetStore from "./store";
 
 // This is a list of all the modules that can be added
 // TODO: Rather then these being hard coded, should these be dynamically built based on user prefs?
 // TODO: These need to be controlled within each widget, not hardcoded here
 const modules = [
   "news",
   "interests",
   "collab",
   "events",
   "links",
   "policies",
   "forms",
 ];
 const adminModules = [...modules, 'announcements'];
 
 /**
  * Components
  *
  * Import any components and then make them accessible to the main application
  * Dynamically import so that they are only loaded if needed
  *
  * TODO: Start import Index only, then look to see if we need to expand at all
  */
 const widgets = [];
 adminModules.forEach((module) => {
   import(`./${module}`); // import indexes so we can init any module specific components too
   Vue.component(`${module}-widget`, () =>
     import(`./${module}/components/Index.vue`)
   );
 });
 
 /**
  * Store
  *
  * Here we want to import all the widget stores, and "namespace" them against the widget store
  *
  * TODO: Would be great to have a way of doing this dynamically
  */
 store.registerModule("widgets", WidgetStore);
 
 adminModules.forEach((module) => {
   import(`./${module}/store`).then((resp) => {
     store.registerModule(["widgets", module], resp.default);
   });
 });
 
 export { modules, adminModules };
